import { ClassValue } from 'clsx';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { i18n } from '@shared/util/i18n';
import classNames from './DefaultError.module.css';

interface Props {
  message?: string;
  isRounded?: boolean;
  className?: ClassValue;
}

export function DefaultError({ message, isRounded = true, className }: Props) {
  const errorMessage = message ?? i18n('errors.loading');

  return (
    <View className={[classNames.defaultError, isRounded && classNames.rounded, className]}>
      <Text danger align="center">
        {errorMessage}
      </Text>
    </View>
  );
}
